const Rellax = require('rellax')
const $ = require("jquery");

const start = async function(rellaxClass) {
    await setTimeout(async () => {
        // var rellax = new Rellax(rellaxClass);
        // rellax.refresh();
        // if ($(document).width() < 992) {
        //     rellax.destroy();
        // }
    }, 300)
}

const stop = async function(rellaxClass) {
    // var rellaxElements = document.getElementsByClassName(rellaxClass)
    // if (rellaxElements && rellaxElements.length > 0) {
    //     var rellax = new Rellax(rellaxClass);
    //     rellax.destroy();
    //
    // }
}



module.exports = {
    start: start,
    stop: stop
}
